export default __webpack_public_path__ + "static/media/ovens.925941d2.png";